import React from "react";
import { requireAuth } from "utilities/auth";
import RegistryEditor from "components/Settings/RegistryEditor";
import { useBanks } from "hooks/useRegistries";
import { apiRoutes } from "constants/apiRoutes";
import { Landmark } from "lucide-react";

/**
 * BanksRegistry (SOUND-672) — /settings/banks. Internal-only.
 *
 * The last link in the AGENT -> PROCESSOR -> SPONSOR BANK chain: the sponsor
 * bank sitting behind a processor. It replaces `mids.acquiringBank`, a free-text
 * field that was NULL on 256 of 258 MIDs — a registry exists so the answer is
 * pickable rather than retyped.
 *
 * All behaviour lives in the shared RegistryEditor; agents and banks carry the
 * same four fields, so this file is configuration, not logic.
 */
function BanksRegistry() {
  return (
    <RegistryEditor
      title="Banks"
      subtitle="Sponsor banks — the acquiring bank behind a processor. One processor can sit on several: Kurv writes to BMO, Esquire, Merrick and Central Bank of St. Louis."
      icon={Landmark}
      noun="bank"
      idKey="bankId"
      useList={useBanks}
      routes={{
        create: apiRoutes.createBank,
        update: apiRoutes.updateBank,
        remove: apiRoutes.deleteBank,
      }}
      createHint="Add a sponsor bank the seed did not cover."
      emptyDescription="Add the sponsor banks behind your processors so MIDs stop carrying a free-text bank name."
      tagsHint="Free-form labels for grouping and search — e.g. the processors that sponsor through this bank."
    />
  );
}

export default requireAuth(BanksRegistry);
